import { useEffect, useMemo } from 'react';
import { useActions } from '../../providers/actions-provider/actions.context';
import { useStore } from '../../../store';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const GetManageGroupTypes = () => {
  const { facilityActions } = useActions();
  const { groupTypes } = useStore();

  useEffect(() => {
    facilityActions.getGroupTypes();
  }, []);

  return useMemo(() => ({ ...groupTypes, data: Object.values(groupTypes.data) }),
    [groupTypes]);
};

export default GetManageGroupTypes;
